import type { Favorite, FavoriteCreateRequest, PaginatedFavoriteList } from '@openapi'
import type { GetFavoritesParams } from '@lib/types/favorites'

/**
 * Get a list of favorites
 */
export function getFavorites(payload?: GetFavoritesParams): Promise<PaginatedFavoriteList> {
  return this.API.request('get_favorites', payload)
}

/**
 * Create a favorite
 */
export function createFavorite(payload: FavoriteCreateRequest): Promise<Favorite> {
  return this.API.request('create_favorite', payload)
}

/**
 * Delete a favorite
 */
export function deleteFavorite(payload: { favorite_id: Favorite['id'] }): Promise<void> {
  return this.API.request('delete_favorite', payload)
}
